module.exports = __webpack_public_path__ + "src/assets/fonts/方正颜宋简体.d24e6d13.TTF";